import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { Check, X } from 'lucide-react';
export function ForWhomSection() {
  return <section className="py-24 px-4 bg-[var(--bg-primary)]" data-id="element-30">
      <div className="max-w-4xl mx-auto" data-id="element-31">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-32">
          {/* For You */}
          <SectionWrapper delay={0} data-id="element-33">
            <div data-id="element-34">
              <h3 className="text-2xl font-serif text-[var(--text-primary)] mb-6 flex items-center" data-id="element-35">
                <span className="w-8 h-1 bg-[var(--green-soft)] mr-3" data-id="element-36"></span>
                Esto es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-37">
                {['eres mujer 40+ y el patrón 2–4am te está rompiendo', 'ya probaste “cositas” y nada se sostiene', 'quieres algo práctico, sin vocabulario médico, sin drama'].map((item, i) => <li key={i} className="flex items-start text-[var(--text-secondary)]" data-id="element-38">
                    <Check className="w-5 h-5 text-[var(--green-soft)] mt-1 mr-3 shrink-0" data-id="element-39" />
                    <span data-id="element-40">{item}</span>
                  </li>)}
              </ul>
            </div>
          </SectionWrapper>

          {/* Not For You */}
          <SectionWrapper delay={0.2} data-id="element-41">
            <div data-id="element-42">
              <h3 className="text-2xl font-serif text-[var(--text-primary)] mb-6 flex items-center" data-id="element-43">
                <span className="w-8 h-1 bg-[var(--red-soft)] mr-3" data-id="element-44"></span>
                Esto NO es para ti si:
              </h3>
              <ul className="space-y-4" data-id="element-45">
                {['buscas una “cura” o promesas médicas', 'quieres que alguien te hipnotice por ti', 'no vas a seguir un protocolo 14 noches'].map((item, i) => <li key={i} className="flex items-start text-[var(--text-secondary)]" data-id="element-46">
                    <X className="w-5 h-5 text-[var(--red-soft)] mt-1 mr-3 shrink-0" data-id="element-47" />
                    <span data-id="element-48">{item}</span>
                  </li>)}
              </ul>
            </div>
          </SectionWrapper>
        </div>
      </div>
    </section>;
}